import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const SessionWarning = () => {
  const { sessionWarning, extendSession, logout } = useAuth();

  if (!sessionWarning) return null;

  const handleExtendSession = () => {
    extendSession();
    // Here you could also refresh the token if you have a refresh endpoint
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#ff9800',
      color: 'white',
      padding: '12px 20px',
      zIndex: 1000,
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div>
        <strong>Session Expiring Soon</strong>
        <p style={{ margin: '4px 0 0 0', fontSize: '14px' }}>
          You have been inactive for 30 minutes and your session will expire soon. Please interact with the app to stay logged in.
        </p>
      </div>
      <div>
        <button
          onClick={handleExtendSession}
          style={{
            backgroundColor: '#4caf50',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            marginRight: '8px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Stay Logged In
        </button>
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Logout Now
        </button>
      </div>
    </div>
  );
};

export default SessionWarning;
